angular.module("Main").controller("ShopStep1Controller", ["$rootScope", "$scope", "$localStorage", "$state", "$window", "$stateParams", "$location", "$translate", "$uibModal", "ShopService", "PaymentService", "BookingService", "SessionService",
    function ($rootScope, $scope, $localStorage, $state, $window, $stateParams, $location, $translate, $uibModal, ShopService, PaymentService, BookingService, SessionService) {
        var vm = this;

        var loginHandler = $rootScope.$on("login", function () {
            checkUser();
            init()
        });
        var logoutHandler = $rootScope.$on("logout", function () {
            SessionService.clear('globals', 'shopData');
            $localStorage.user = {};
            init()
        });
        $scope.$on("destroy", function () {
            unregisterEventHandler();
        });

        var xlarge = 1700;
        var large = 1500;
        var medium = 1200;
        var small = 900;
        var xs = 450;

        function checkLimitLength() {
            if ($window.innerWidth >= xlarge) {
                vm.limitLength = 8;
            }
            else if ($window.innerWidth >= large) {
                vm.limitLength = 6;
            }
            else if ($window.innerWidth >= medium) {
                vm.limitLength = 5;
            } else if ($window.innerWidth >= small) {
                vm.limitLength = 4;
            } else if ($window.innerWidth >= xs) {
                vm.limitLength = 3;
            }
        }

        checkLimitLength();

        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
            });
        }

        function loadConfigs() {
            BookingService.loadLayoutConfiguration().then(function (data) {
                vm.layoutSettings = angular.fromJson(data.Layout);
                getKursbuchungLayouKonfiguration();
            })
        }

        function loadCurrency() {

            return new Promise((resolve) => {
                BookingService.getCurrency().then(function (data) {
                    vm.currency = data;
                    if (vm.currency.Waehrung === "EUR")
                        vm.currency.Waehrung = "€";
                    resolve(vm);
                })

            })
        }

        //ToDo prüfen was wenn id false/ abfangen => kein Link
        if (!SessionService.getSessionId()) {
            if (_.isUndefined($stateParams.id)) {
                SessionService.setAuthDataId($stateParams.cid, false);
                $state.go('shop', {sid: SessionService.getSessionId(), cid: $stateParams.cid, id: false});
            } else {
                SessionService.setAuthDataId($stateParams.cid, $stateParams.id, false, $stateParams.id === 'tt');
                $state.go('shop', {sid: SessionService.getSessionId(), cid: $stateParams.cid, id: $stateParams.id});
            }
            start();
        } else
            start();

        async function start() {
            try {
                //await SessionService.clear('shopData');
                await checkUser();
                await loadCurrency();
                init();
            }
            catch {

            }
        }

        function unregisterEventHandler() {
            loginHandler();
            logoutHandler();
        }

        function checkUser() {
            if ($localStorage.user && !_.isUndefined($localStorage.user.expiryTime)) {
                let expiryTime = JSON.parse($localStorage.user.expiryTime);
                let now = new Date;
                if (now.getTime() > expiryTime) {
                    SessionService.clear('globals', 'shopData');
                    vm.isLoggedIn = false;
                    vm.username = "";
                    $localStorage.user = {};
                    $rootScope.$emit("logout");
                    $state.go('shop', {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()})
                }
            }

            vm.isMember = $localStorage.user && $localStorage.user.username && $localStorage.user.username !== '' ? $localStorage.user.isMember : false;
            vm.isLoggedIn = !_.isNil($localStorage.user) && !_.isUndefined($localStorage.user.username);
            vm.currentUser = $localStorage.user;
            vm.username = $localStorage.user ? $localStorage.user.username : null;
            vm.isPayPal = $localStorage.user ? $localStorage.user.isPayPal : false;
            vm.isBonitaet = $localStorage.user ? $localStorage.user.isBonitaet : false;
        }

        async function init() {
            try {
                await checkUser();
                await loadConfigs();
                await checkArtikel()
            }
            catch {

            }
        }

        function checkArtikel() {
            SessionService.clear('shopData');
            vm.linkInactiv = false;
            ShopService.checkArtikelLinkConfig($stateParams.id).then(function (data) {
                if (data.data.LinkIdNotFound === true || data.data.IsInactiv) {
                    vm.linkInactiv = true;
                    vm.isInFuture = data.IsInFuture;
                    vm.isInPast = data.IsInPast;
                    if (data.data.IsInFuture === true) {
                        vm.futureDate = data.data.FutureDate;
                    }
                } else {
                    if(data.Artikel.length===0) {
                        vm.linkInactiv = true;
                    }
                    else {
                        if(vm.isLoggedIn) {
                            let articleNrs = _.map(data.Artikel, 'Nr');
                            ShopService.checkMvPrices(articleNrs, vm.currentUser.uid).then(function (prices) {
                                vm.prices = prices;
                                _.forEach(data.Artikel, function (artikel) {
                                    let f1 = _.find(prices, {'ArticleNr': artikel.Nr});
                                    artikel.Preis = f1.Price;
                                })
                            }).catch(function () {
                                    $state.go("shop_fail", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
                                }
                            )
                        }
                        
                        vm.allArticles = _.orderBy(data.Artikel, [
                            (item) => (item.Sortierung === 0 ? Infinity : item.Sortierung)
                        ], ['asc']);

                        if (vm.limitLength) {
                            vm.chunckedArticles = _.chunk(vm.allArticles, vm.limitLength);
                            vm.articles = vm.chunckedArticles[0];
                            vm.showMover = vm.allArticles.length > vm.limitLength;
                            vm.begin = 0;
                        } else {
                            vm.articles = vm.allArticles;
                        }

                    }
                }
            })
        }

        vm.selectArticle = function (article, currency) {
            article.SliderData = {};
            article.SliderData.IsSlider = vm.IsSlider;
            article.SliderData.StartTimeSlider = vm.StartTimeSlider;
            article.SliderData.EndeTimeSlider = vm.EndeTimeSlider;

            SessionService.setShopData(article, currency, false);
            unregisterEventHandler();
            $state.go('shop_overview', {cid: $stateParams.cid, id: $stateParams.id})

        };

        vm.moveLeft = function () {
            vm.begin--;
            if (vm.begin < 0) {
                vm.begin = 0;
            }
            vm.articles = vm.chunckedArticles[vm.begin];
        };

        vm.moveRight = function () {
            vm.begin++;
            if (vm.begin + 1 > vm.chunckedArticles.length) {
                vm.begin = 0
            }
            vm.articles = vm.chunckedArticles[vm.begin];
        };

        vm.goToAngebot = function () {
            $state.go('shop', {cid: $stateParams.cid, id: $stateParams.id});
            vm.openedMenuBar = false;
        }

        vm.openMenuBar = function () {
            if (vm.openedMenuBar === false) {
                vm.openedMenuBar = true;
            } else {
                vm.openedMenuBar = false;
            }
        };

    }])